module.exports = __webpack_public_path__ + "static/image5-78ed725dbd190946fd1da80d74101bb4.jpg";